import { getBridge } from "@/src/lib/bridge/bridge";
import { MessageType } from "@/src/lib/bridge/types";

/**
 * Daily market summary 已读落定后同步到原生 DataStore（§2.4 hybrid 壳）。
 * 浏览器 PWA / 非 App 环境 no-op。
 */
export function syncDailyMarketReadToNativeIfInApp(
  ownerId: string,
  date: string,
): void {
  if (!ownerId || !/^\d{8}$/.test(date)) {
    return;
  }

  const bridge = getBridge();
  if (!bridge.isInApp()) {
    return;
  }

  try {
    bridge.send(MessageType.SYNC_DAILY_MARKET_READ, { ownerId, date });
  } catch {
    // localStorage 仍是 WebView 内真相源；bridge 失败不阻断 markRead
  }
}
